var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-container',[_c('mu-breadcrumbs',_vm._l((_vm.items),function(item){return _c('mu-breadcrumbs-item',{key:item.text,attrs:{"to":item.to,"disabled":item.disabled}},[_vm._v(_vm._s(item.text))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }